(() => {
  const DESKTOP_BREAKPOINT = 1200;
  const OPEN_CLASS = "submenu-opened";
  const BODY_OPEN_CLASS = "menu-open";

  const isMobileMenu = () =>
    !window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches ||
    document.body.classList.contains("mobile-nav");

  const getNav = () => document.querySelector("#wt-drawer-nav .wt-page-nav-mega");

  const expandFirstItems = () => {
    const nav = getNav();
    if (!nav || !isMobileMenu()) return;

    if (nav.querySelector(`.${OPEN_CLASS}`)) return;

    const parentLink = nav.querySelector(".wt-page-nav-mega__link--parent");
    if (!parentLink) return;

    const submenuWrapper = parentLink.nextElementSibling;
    parentLink.classList.add(OPEN_CLASS);

    const submenuLink = submenuWrapper?.querySelector(
      ".wt-page-nav-mega__sublist__link--parent",
    );
    if (!submenuLink) return;

    submenuLink.classList.add(OPEN_CLASS);
  };

  const activateExpandedLinks = () => {
    const nav = getNav();
    if (!nav || !isMobileMenu()) return;

    nav.querySelectorAll(`.${OPEN_CLASS}`).forEach((openedLink) => {
      const container = openedLink.nextElementSibling;
      if (!container) return;
      const level = Number(openedLink.dataset.menuLevel) + 1;
      setTabindex(container.querySelectorAll(`a[data-menu-level="${level}"]`), "0");
    });
  };

  const isMenuOpen = () => document.body.classList.contains(BODY_OPEN_CLASS);

  expandFirstItems();
  if (isMenuOpen()) activateExpandedLinks();

  let wasOpen = isMenuOpen();

  new MutationObserver(() => {
    const isOpen = isMenuOpen();
    if (isOpen === wasOpen) return;

    wasOpen = isOpen;
    if (isOpen) {
      expandFirstItems();
      activateExpandedLinks();
    }
  }).observe(document.body, { attributeFilter: ["class"] });
})();
